import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';

@Component({
  selector: 'app-add-package-cancellation-policy',
  templateUrl: './add-package-cancellation-policy.component.html',
  styleUrls: ['./add-package-cancellation-policy.component.css']
})
export class AddPackageCancellationPolicyComponent implements OnInit {

  @Input() packageForm: DVFormGroup;

  constructor() { }

  ngOnInit() {
  }

}
